import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import {
  productListByFilter,
  saveProductMutation,
} from '../../../shared/queries/Product';
import { receivingCategoryListByFilter } from '../../../shared/queries/ReceivingCategory';
import GraphQL from '../../../GraphQL';
import ProductForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';

const ProductFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({ id: 0 });
  const [formOn, setFormOn] = useState(false);
  const [listOfCategory, setListOfCategory] = useState([]);

  function backClickHandler() {
    history.push('/minime/produto');
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const loadAllCategory = () => {
    const filter = {
      filterByStatus: true,
      updaterId: 0,
      active: true,
      id: 0,
    };
    const query = receivingCategoryListByFilter(filter);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.receivingCategoryListByFilter) {
          res.receivingCategoryListByFilter =
            res.receivingCategoryListByFilter.map((item) => ({
              id: item.id,
              value: item.id,
              label: t(`${item.name}`),
            }));
          setListOfCategory(res.receivingCategoryListByFilter);
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch((error) => {
        hideLoading();
        if (error) {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        }
      });
  };

  function findById(id) {
    showLoading();
    const filter = {
      filterByStatus: false,
      updaterId: 0,
      active: true,
      id,
      value: 0,
    };
    const query = productListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.productListByFilter) {
          setDto({
            ...res.productListByFilter[0],
            category: {
              id: res.productListByFilter[0].category.id,
              value: res.productListByFilter[0].category.id,
              label: t(`${res.productListByFilter[0].category.name}`),
            },
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch((error) => {
        hideLoading();
        if (error.response) {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        }
      });
  }

  const handleSubmit = (values) => {
    const mutation = saveProductMutation(values);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        hideLoading();
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
        loadAllCategory();
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  useEffect(() => {
    loadAllCategory();
    setDto({ active: true, id: 0 });
  }, []);

  return (
    <SmartCard title={t('panels.produto')}>
      {formOn ? (
        <ProductForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
          category={listOfCategory}
        />
      ) : null}
    </SmartCard>
  );
};

ProductFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ProductFormHandler)
);
